<script lang="ts" setup></script>

<template>
  <span class="text-italic text-weight-regular text-body">
    - {{ $t('gen_optional') }}
  </span>
</template>

<style lang="scss" scoped></style>